"use client";

import { useRef, useEffect } from "react";
import { useAuthStore } from "@/store/authStore";

export default function StoriesPlaylist({ playlists, activeId, onSelect }) {
    const { isAuthenticated, user } = useAuthStore();
    const scrollRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollLeft = scrollRef.current.scrollWidth;
            }
        }, 0);

        return () => clearTimeout(timer);
    }, [playlists]);

    const scrollItemToCenter = (element) => {
        if (!scrollRef.current || !element) return;

        const container = scrollRef.current;
        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        const offset =
            elementRect.left -
            containerRect.left -
            containerRect.width / 2 +
            elementRect.width / 2;

        container.scrollTo({
            left: container.scrollLeft + offset,
            behavior: "smooth",
        });
    };

    return (
        <div className="w-full px-2" dir="rtl">
            <div
                ref={scrollRef}
                className="
                    flex gap-3 px-4 py-3
                    md:max-w-xl md:mx-auto
                    snap-x snap-mandatory
                    touch-pan-x scrollbar-hide
                "
                style={{
                    overflowX: "auto",
                    overflowY: "hidden",
                    WebkitOverflowScrolling: "touch",
                    direction: "rtl",
                }}
            >
                {/* all */}
                <div
                    onClick={(e) => {
                        onSelect("all");
                        scrollItemToCenter(e.currentTarget);
                    }}
                    className="flex flex-col items-center snap-start shrink-0 cursor-pointer group"
                >
                    <div
                        className={`
                            p-[3px] rounded-full transition-all
                            ${activeId === "all"
                                ? "bg-green-500 scale-105"
                                : "bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600"
                            }
                        `}
                    >
                        <div className="bg-[#001f2d] p-[2px] rounded-full">
                            <img
                                src="/assets/about-2.jpg"
                                alt="همه"
                                className="w-16 h-16 md:w-18 md:h-18 rounded-full object-cover"
                            />
                        </div>
                    </div>
                    <span className="text-xs mt-1 w-16 text-center line-clamp-2 text-white">
                        همه
                    </span>
                </div>

                {/* new */}
                {isAuthenticated && (
                    <div
                        onClick={(e) => {
                            onSelect('new');
                            scrollItemToCenter(e.currentTarget);
                        }}
                        className="flex flex-col items-center snap-start shrink-0 cursor-pointer group"
                    >
                        <div
                            className={`
                                p-[3px] rounded-full transition-all
                                ${activeId === 'new'
                                    ? "bg-green-500 scale-105"
                                    : "bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600"
                                }
                            `}
                        >
                            <div className="bg-[#001f2d] p-[2px] rounded-full">
                                <img
                                    src="/assets/new.jpg"
                                    alt="شانسی"
                                    className="w-16 h-16 md:w-18 md:h-18 rounded-full object-cover"
                                />
                            </div>
                        </div>
                        <span className="text-xs mt-1 w-16 text-center line-clamp-2 text-white">
                            شانسی
                        </span>
                    </div>
                )}

                {/* playlists */}
                {playlists.map((p) => {
                    const active = activeId === p.id;

                    return (
                        <div
                            key={p.id}
                            onClick={(e) => {
                                onSelect(p.id);
                                scrollItemToCenter(e.currentTarget);
                            }}
                            className="flex flex-col items-center snap-start shrink-0 cursor-pointer group"
                        >
                            <div
                                className={`
                                    p-[3px] rounded-full transition-all
                                    ${active
                                        ? "bg-green-500 scale-105 shadow-[0_0_15px_rgba(255,255,255,0.4)]"
                                        : "bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600"
                                    }
                                `}
                            >
                                <div className="bg-[#001f2d] p-[2px] rounded-full">
                                    <img
                                        src={process.env.NEXT_PUBLIC_ASSETS_URL + (p.hero_image || p.image)}
                                        alt={p.hero_name || p.name}
                                        loading="lazy"
                                        className="w-16 h-16 md:w-18 md:h-18 rounded-full object-cover"
                                    />
                                </div>
                            </div>
                            <span className="text-xs mt-1 w-16 text-center line-clamp-2 text-white">
                                {p.hero_name || p.name}
                            </span>
                        </div>
                    );
                })}

                {/* popular */}
                <div
                    onClick={(e) => {
                        onSelect('popular');
                        scrollItemToCenter(e.currentTarget);
                    }}
                    className="flex flex-col items-center snap-start shrink-0 cursor-pointer group"
                >
                    <div
                        className={`
                            p-[3px] rounded-full transition-all
                            ${activeId === 'popular'
                                ? "bg-green-500 scale-105"
                                : "bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600"
                            }
                        `}
                    >
                        <div className="bg-[#001f2d] p-[2px] rounded-full">
                            <img
                                src="/assets/popular.jpg"
                                alt="محبوب ترین"
                                className="w-16 h-16 md:w-18 md:h-18 rounded-full object-cover"
                            />
                        </div>
                    </div>
                    <span className="text-xs mt-1 w-16 text-center line-clamp-2 text-white">
                        محبوب ترین
                    </span>
                </div>
            </div>
        </div>
    );
}
